import axios from "axios";

axios.defaults.timeout = 5000;

//返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'//配置请求头

// axios.defaults.baseURL = 'https://api.hzcitybrain.com/cockpit/caq-2650/public/cabin/common/apiDataRequest/';
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';

//POST传参序列化(添加请求拦截器)

axios.interceptors.request.use((config) => {
  //在发送请求之前做某件事
  if(config.method === 'post'){
    config.data = JSON.stringify(config.data);
  }
  return config;
},(error) =>{
  console.log('错误的传参')
  return Promise.reject(error);

});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
  //对响应数据做些事
  if(!res.data.success){
    return Promise.resolve(res);
  }
  return res;

}, (error) => {
  console.log('网络异常')
  return Promise.reject(error);

});
export default axios;

